module.exports = __webpack_public_path__ + "img/deniz-verena-praun-v2.19957095.jpg";